import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";

@Injectable()
export class PhoneNumberService {
  constructor(private http: HttpClientService) {}

  public deletePhoneNumber(phone_id): Observable<any> {
    return this.http
      .delete("/api/phone_number/" + phone_id)
      .pipe(tap((_) => console.log("PhoneNumber.deletePhoneNumber: Ok.")));
  }

  public updatePhoneNumber({
    phone_id,
    info = undefined,
    category = undefined,
    origin = undefined,
    communication_wp = undefined,
    principal = undefined,
  }): Observable<any> {
    const params = {
      info: info,
      category: category,
      origin: origin,
      communication_wp,
      principal,
    };
    return this.http
      .put("/api/phone_number/" + phone_id, params)
      .pipe(tap((_) => console.log("PhoneNumber.updatePhoneNumber: Ok.")));
  }

  public createPhoneNumber(
    contactable: string,
    id: number | string,
    params: {
      info: string;
      category: string;
      principal?: boolean;
      communication_wp?: boolean;
    }
  ): Observable<any> {
    const requestParams = {
      ...params,
      contactable,
      id,
    };
    return this.http
      .post("/api/phone_number", requestParams)
      .pipe(tap((_) => console.log("PhoneNumber.createPhoneNumber: Ok.")));
  }
}
